export const ENDPOINTS = {
  codeVerifier: '/api/auth/code-verifier',
  vkCallback: '/api/auth/vk/callback',
  createPayment: '/api/yookassa/create-payment',
  mockVkCallback: '/api/auth/mock-vk/callback',
  checkPaymentStatus: '/api/yookassa/check-payment-status',
  mockCreatePayment: '/api/mocks/create-payment',
  mockPaymentResult: '/api/mocks/payment-result',
  paymentSucceesUrl: '/api/payment-success',
  continueSignUp: '/api/sign-up/continue',
  cancelSignUp: '/api/sign-up/cancel',
  deleteSignUpSession: '/api/sign-up/delete-session',
  clearSignUpCookies: '/api/sign-up/clear-session-cookies',
  keepAlive: '/api/session/keep-alive',
  logout: '/api/auth/logout',
  logError: '/api/log-error'
};

export const YOOKASSA_API_URL = 'https://api.yookassa.ru/v3/payments';
